import { Observable } from 'rxjs';
import { publishReplay, refCount } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import {HttpClientService} from '../httpClient/httpclient.service';
import {ServiceType} from '../../models/service-type.model';
import 'rxjs/Rx';
import { MessageService } from 'primeng/api';

@Injectable()
export class ServiceTypeService {

  serviceTypes: ServiceType[];
  serviceTypeEditing: ServiceType;

private cachedFields: Observable<any>

  constructor (
    private h: HttpClientService,
    private srvNotify: MessageService
  ) { }

  getAll(): Observable<ServiceType[]> {
    return this.h.get('/koncentro-common/serviceType/serviceTypes')
      .map(res => {
        return this.serviceTypes = res;
      });
  }

  delete(record) {
    return this.h.delete('/koncentro-common/serviceType/serviceTypes/' + record.id)
      .map(res => {
        this.serviceTypes.splice(this.serviceTypes.indexOf(record), 1);
        this.srvNotify.add({severity: 'info', summary: 'Confirmed', detail: 'Service Type deleted'});
      });
  }

  post(newData) {
    return this.h.post('/koncentro-common/serviceType/serviceTypes/', newData)
      .map(res => {
        newData.id = res.id;
        this.serviceTypes.push(newData);
        this.srvNotify.add({severity: 'info', summary: 'Success', detail: 'Operation success'});
      });

  }

  put(newData) {
    return this.h.put('/koncentro-common/serviceType/serviceTypes/', newData)
      .map(res => {
        Object.assign(this.serviceTypeEditing, newData);
        this.srvNotify.add({severity: 'info', summary: 'Success', detail: 'Operation success'});
      });
  }

  getFields() {
    if (!this.cachedFields) {
      this.cachedFields = this.h.get('/koncentro-common/schema/ServiceTypeDto').pipe(
        publishReplay(1), // this tells Rx to cache the latest emitted
        refCount() // and this tells Rx to keep the Observable alive as long as there are any Subscribers
      )
    }
    return this.cachedFields;
  }



}



// WEBPACK FOOTER //
// ./src/app/services/service-type/service-type.service.ts